import cn from 'classnames';
import React, { PropsWithChildren } from 'react';
import { DropdownMenu, DropdownToggle } from '../dropdown';
import { MenuProps, ToggleProps } from '../dropdown/Dropdown';

type GroupProps = PropsWithChildren<{
  size?: ButtonGroupSize;
}>;

interface ButtonData {
  family?: 'outline' | 'link';
  type?: 'primary' | 'success' | 'warning' | 'danger';
}
type OverflowProps = PropsWithChildren<{
  open?: boolean;
  button: ButtonData;
  closeOnItemClick: boolean;
  onToggle?: () => void;
}>;

type ButtonGroupSize = 'sm';

export const ButtonGroup = React.forwardRef<HTMLDivElement, GroupProps>(
  (props, ref) => {
    const { children, size } = props;
    const classNames = cn('btn-group', {
      [`btn-${size}`]: size
    });

    return (
      <div ref={ref} className={classNames}>
        {children}
      </div>
    );
  }
);

export const ButtonGroupOverflow = React.forwardRef<
  HTMLDivElement,
  OverflowProps
>((props, ref) => {
  const { children, open, button, closeOnItemClick, onToggle } = props;
  const classNames = cn('btn-group-overflow', { open });

  const onItemClick = () => {
    if (closeOnItemClick && onToggle) {
      onToggle();
    }
  };

  const renderOverflowChildren = () => {
    return React.Children.map(children, child => {
      if (
        React.isValidElement<MenuProps>(child) &&
        child.type === DropdownMenu
      ) {
        return React.cloneElement(child, {
          onItemClick,
          visible: open
        });
      } else if (
        React.isValidElement<ToggleProps>(child) &&
        child.type === DropdownToggle
      ) {
        return React.cloneElement(child, {
          button: { ...button },
          onToggle
        });
      } else {
        return null;
      }
    });
  };

  return (
    <div ref={ref} className={classNames}>
      {renderOverflowChildren()}
    </div>
  );
});
